import { useState } from "react";
import Marquee from "react-fast-marquee";

/* All logos are stored locally at /public/logos/<slug>.svg and rendered
   monochrome-white via CSS filter so they sit consistently on the dark theme. */
const clients = [
  { name: "Microsoft",    slug: "microsoft" },
  { name: "Intel",        slug: "intel" },
  { name: "IBM",          slug: "ibm" },
  { name: "Accenture",    slug: "accenture" },
  { name: "Cognizant",    slug: "cognizant" },
  { name: "Capgemini",    slug: "capgemini" },
  { name: "Deloitte",     slug: "deloitte" },
  { name: "HCLTech",      slug: "hcltech" },
  { name: "Wipro",        slug: "wipro" },
  { name: "Barclays",     slug: "barclays" },
  { name: "Saudi Aramco", slug: "saudiaramco" },
];

function ClientLogo({ c }) {
  const [failed, setFailed] = useState(false);
  return (
    <div
      data-testid={`client-logo-${c.slug}`}
      className="group inline-flex items-center shrink-0"
      title={c.name}
    >
      {!failed ? (
        <img
          src={`/logos/${c.slug}.svg`}
          alt={c.name}
          onError={() => setFailed(true)}
          loading="lazy"
          className="logo-img h-7 md:h-9 w-auto opacity-60 group-hover:opacity-100 transition-opacity duration-300"
        />
      ) : (
        <span
          className="font-display font-bold uppercase tracking-tight text-xl md:text-2xl text-white/60 group-hover:text-white whitespace-nowrap transition-colors duration-300"
          style={{ letterSpacing: "-0.02em" }}
        >
          {c.name}
        </span>
      )}
    </div>
  );
}

export default function LogoMarquee() {
  return (
    <section
      data-testid="logo-marquee"
      className="py-14 md:py-20 border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-8">
          <span className="h-px w-8 bg-white/30" />
          <span className="label-eyebrow">Trusted by global teams at</span>
        </div>
      </div>
      <div className="fade-x">
        <Marquee gradient={false} speed={45} pauseOnHover>
          <div className="flex items-center gap-14 md:gap-20 px-10">
            {clients.concat(clients).map((c, i) => (
              <div key={`${c.slug}-${i}`} className="inline-flex items-center">
                <ClientLogo c={c} />
                <span
                  className="ml-14 md:ml-20 h-1.5 w-1.5 rounded-full bg-white/15"
                  aria-hidden
                />
              </div>
            ))}
          </div>
        </Marquee>
      </div>

      <style>{`
        /* Force monochrome-white rendering across heterogeneous brand SVGs */
        .logo-img {
          filter: brightness(0) invert(1);
          -webkit-filter: brightness(0) invert(1);
        }
      `}</style>
    </section>
  );
}
